module.exports = __webpack_public_path__ + "components/flag/static/square/km-7b2176c96ac07966f34eb613f84dbd4a.svg";